@import 'styles/variables';
@import 'styles/mixins.scss';

.rightContent {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  width: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url('./fold-subway.svg');
  background-repeat: no-repeat;

  @include for-tablet-portrait-max {
    display: none;
  }

  .rightTitle {
    @include publico-regular;
    font-size: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: 17px;
  }

  .rightQuote {
    color: var(--neutral-90);
    font-size: 16px;
    text-align: center;
    line-height: 26px;
    width: 255px;
    margin: 0 16px;
  }

  .leftMark,
  .rightMark {
    color: var(--neutral-30);
    font-size: 40px;
    opacity: 0.3;
  }

  .rightMark {
    float: right;
  }

  .leftMark {
    float: left;
  }

  .rightCredit {
    @include sm-medium;

    color: var(--neutral-90);
    text-align: center;

    .title {
      @include inter-light;

      color: var(--neutral-40);
    }
  }

  .rightAvatar {
    margin: 10px auto 8px;
  }
}
